var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 9H13.0039V11H5.00391V14L0.00390625 10L5.00391 6V9ZM4.00391 16H6.71191C7.86659 17.0183 9.29059 17.6819 10.813 17.9109C12.3355 18.14 13.8917 17.9249 15.2949 17.2915C16.6981 16.6581 17.8888 15.6332 18.724 14.3398C19.5592 13.0465 20.0034 11.5396 20.0034 10C20.0034 8.46042 19.5592 6.95354 18.724 5.66019C17.8888 4.36683 16.6981 3.34194 15.2949 2.7085C13.8917 2.07506 12.3355 1.85998 10.813 2.08906C9.29059 2.31815 7.86659 2.98167 6.71191 4H4.00391C4.93457 2.75718 6.14224 1.74851 7.53098 1.05414C8.91972 0.359775 10.4513 -0.00116364 12.0039 2.81829e-06C17.5269 2.81829e-06 22.0039 4.477 22.0039 10C22.0039 15.523 17.5269 20 12.0039 20C10.4513 20.0012 8.91972 19.6402 7.53098 18.9459C6.14224 18.2515 4.93457 17.2428 4.00391 16Z",
    fill: "#F4F4F4",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.54d1db5cacfa906db1f16a704607d275.svg";
export { ForwardRef as ReactComponent };